<template>
  <el-form :inline="true">

    <!--<el-form-item label="id" prop="id">-->
      <!--<el-input-number v-model="searchForm.id"></el-input-number>-->
    <!--</el-form-item>-->
    <!--<el-date-picker-->
      <!--v-model="searchForm.startBirthday"-->
      <!--type="date"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--placeholder="起始created_at时间">-->
    <!--</el-date-picker>-->
    <!--<el-date-picker-->
      <!--v-model="searchForm.endBirthday"-->
      <!--type="date"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--placeholder="截止created_at时间">-->
    <!--</el-date-picker>-->
    <!--<el-form-item label="入校时间" prop="school_start">-->
      <!--<el-input v-model="searchForm.school_start"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="毕业时间" prop="school_end">-->
      <!--<el-input v-model="searchForm.school_end"></el-input>-->
    <!--</el-form-item>-->
    <el-form-item label="姓名" prop="name">
      <el-input v-model="searchForm.name"></el-input>
    </el-form-item>
    <el-form-item label="身份证号" prop="card_number">
      <el-input v-model="searchForm.card_number"></el-input>
    </el-form-item>
    <el-form-item label="学校名称" prop="schoole_name">
      <el-input v-model="searchForm.schoole_name"></el-input>
    </el-form-item>
    <!--<el-form-item label="专业名称" prop="magor">-->
      <!--<el-input v-model="searchForm.magor"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="专业类型" prop="magor_type">-->
      <!--<el-input v-model="searchForm.magor_type"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="学籍" prop="school_roll">-->
      <!--<el-input v-model="searchForm.school_roll"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="学习形式" prop="study_func">-->
      <!--<el-input v-model="searchForm.study_func"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="层次" prop="gradation">-->
      <!--<el-input v-model="searchForm.gradation"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="状态" prop="status">-->
      <!--<el-input v-model="searchForm.status"></el-input>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="校（院）长姓名" prop="dean_name">-->
      <!--<el-input v-model="searchForm.dean_name"></el-input>-->
    <!--</el-form-item>-->
    <el-form-item label="证书编号" prop="card_id">
      <el-input v-model="searchForm.card_id"></el-input>
    </el-form-item>
    <el-date-picker
      v-model="searchForm.startCreatedAt"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="创建日期起">
    </el-date-picker>
    <el-date-picker
      v-model="searchForm.endCreatedAt"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="截止日期止">
    </el-date-picker>
    <!--<el-date-picker-->
      <!--v-model="searchForm.startUpdatedAt"-->
      <!--type="date"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--placeholder="起始created_at时间">-->
    <!--</el-date-picker>-->
    <!--<el-date-picker-->
      <!--v-model="searchForm.endUpdatedAt"-->
      <!--type="date"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--placeholder="截止created_at时间">-->
    <!--</el-date-picker>-->
    <el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    name: "UserDetailSearch",
    components: {},
    data() {
      return {
        searchForm: {},
      }
    },
    methods: {
      search() {
        this.$store.commit('user_detail/setSearch', this.searchForm);
        this.$store.dispatch('user_detail/getList')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/user_detail/UserDetailSearch.vue